import React from "react";
import axios from "axios";
import { Button, Modal } from "react-bootstrap";
import { useSchoolContext } from "../components/SchoolDataContext";
export default function SchoolDeleteDialog({
  show,
  setShow,
  onHide,
  id,
  setSuccessMessage,
  setErrorMessage,
}) {
  const context = useSchoolContext();

  const onDelete = async () => {
    try {
      // For schools, we'll use deactivate instead of hard delete
      // If you want hard delete, you'll need to create a delete endpoint
      await context.deactivateSchool(id);
      setSuccessMessage("School Deactivated Successfully");
      onHide();
      
      // Refresh the data
      setTimeout(() => {
        context.setRefetch({ ...context.refetch, schools: true });
      }, 1000);
    } catch (error) {
      console.error("Error deleting school:", error);
      setErrorMessage("Error Removing School");
    }
  };

  return (
    <Modal show={show}>
      <Modal.Header closeButton>
        <Modal.Title>Remove School</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to remove this School? This action will deactivate the school.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            onDelete();
          }}
        >
          Remove
        </Button>
      </Modal.Footer>
    </Modal>
  );
}